import { render } from "./ViolationQuery.vue?vue&type=template&id=68622d56&scoped=true"
import script from "./ViolationQuery.vue?vue&type=script&lang=js"
export * from "./ViolationQuery.vue?vue&type=script&lang=js"

import "./ViolationQuery.vue?vue&type=style&index=0&id=68622d56&scoped=true&lang=css"

import exportComponent from "../../node_modules/@vue/cli-service/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-68622d56"]])

export default __exports__